// extracted by mini-css-extract-plugin
export default {"d-flex":"EditSection_d-flex__NKEYg","btn":"EditSection_btn__7gGt-","modal":"EditSection_modal__+9BsL","input-field":"EditSection_input-field__ash3i"};